
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"annonceur_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categorie_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statut"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pack"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facturation"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_debut"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_fin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leadsDevalides"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"annonceur_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"annonceur_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"categorie_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categorie_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"statut"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statut"}}},{"kind":"Argument","name":{"kind":"Name","value":"pack"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pack"}}},{"kind":"Argument","name":{"kind":"Name","value":"facturation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facturation"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_debut"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_debut"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_fin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_fin"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date_commande"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_lead"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_livraison"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pack"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pk_lead"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pk_pack"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"destockage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categorie"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"civilite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prenom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_naissance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ville"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telephone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adresse"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ip"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pk_template"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pk_categorie"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facturation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"statut"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"motif"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pk_bon_commande"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pk_commande"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fk_provenance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"retour_ws"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"societe"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"designation"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":981}};
    doc.loc.source = {"body":"query (\n        $annonceur_id: ID\n        $categorie_id: ID\n        $statut: String\n        $pack: String\n        $facturation: String\n        $date_debut: String\n        $date_fin: String\n    ) {\n    leadsDevalides\n    (\n        annonceur_id: $annonceur_id\n        categorie_id: $categorie_id\n        statut: $statut\n        pack: $pack\n        facturation: $facturation\n        date_debut: $date_debut\n        date_fin: $date_fin\n\n    ){\n        date_commande\n        date_lead\n        subid\n        date_livraison\n        pack\n        pk_lead\n        pk_pack\n        destockage\n        categorie\n        civilite\n        nom\n        prenom\n        date_naissance\n        cp\n        ville\n        telephone\n        email\n        adresse\n        ip\n        pk_template\n        pk_categorie\n        facturation\n        statut\n        motif\n        pk_bon_commande\n        pk_commande\n        fk_provenance\n        subid\n        retour_ws\n        societe\n        designation\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
